import type { AnimationDataV7, IngredientV7 } from './types/v7';
import type { AnimationDataV8, IngredientV8 } from './types/v8';

/**
 * V7 → V8. The single nullable `characterReferenceAsset` becomes
 * `userReferenceAssets`, a required `StyleReferenceAsset[]` holding only the
 * reference images the user uploaded, and `characterInputMode` is dropped.
 *
 * Pre-V8 a `characterReferenceAsset` could be either a user upload OR a copy of
 * the generated image (distinguished by `characterInputMode`). `userReferenceAssets`
 * only holds genuine uploads, so we carry the old asset forward as a one-element
 * array ONLY when the ingredient was in upload mode; generate-mode seeds,
 * absent, and null values all become an empty array. Both old fields are dropped.
 */
export function v7ToV8(input: AnimationDataV7): AnimationDataV8 {
    const ingredients = input.ingredients?.map(migrateIngredient);
    return { ...input, version: 8, ingredients };
}

function migrateIngredient(ingredient: IngredientV7): IngredientV8 {
    const { characterReferenceAsset, characterInputMode, ...rest } = ingredient;
    const userReferenceAssets =
        characterInputMode === 'upload' && characterReferenceAsset ? [characterReferenceAsset] : [];
    return { ...rest, userReferenceAssets };
}
